// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-10Jde";
var _3 = "fare-26ePW";
var _4 = "price-35wrA";
var _5 = "code-eqFDS";
var _6 = "tooltip-3auCJ";
var _7 = "fee-23OoI";
var _8 = "active-3PYze";
var _9 = "name-1h7tf";
var _a = "name__inner-38Baq";
var _b = "bold-xDwD_";
export { _1 as "__esModule", _2 as "wrapper", _3 as "fare", _4 as "price", _5 as "code", _6 as "tooltip", _7 as "fee", _8 as "active", _9 as "name", _a as "name__inner", _b as "bold" }
export default { "__esModule": _1, "wrapper": _2, "fare": _3, "price": _4, "code": _5, "tooltip": _6, "fee": _7, "active": _8, "name": _9, "name__inner": _a, "bold": _b }
